module.exports = __webpack_public_path__ + "images/line-chart-da6f1392.svg";